<template>
  <div>
    <h1 class="text-2xl font-bold mb-4">Bem-vindo ao painel administrativo</h1>
    <p class="text-gray-600">Use o menu ao lado para acessar as funcionalidades.</p>
  </div>
</template>